export default "__VITE_ASSET__DZNSlZqF__"